import { render } from "./Services2.vue?vue&type=template&id=44d09f37&scoped=true"
import script from "./Services2.vue?vue&type=script&lang=js"
export * from "./Services2.vue?vue&type=script&lang=js"

import "./Services2.vue?vue&type=style&index=0&id=44d09f37&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d09f37"]])

export default __exports__